export default "__VITE_ASSET__BCa_G2n3__"